import React from 'react';

import { orderCommentInput } from './OrderReviewPage.styles';

const OrderReviewComment = (props) => (
  <textarea css={orderCommentInput} {...props} />
);

export default OrderReviewComment;
